var exports = {
  "S_": "x93eb46d8--2800a0--online-booking",
  "lq": "x93eb46d8--2800a0--viewed",
  "BI": "x93eb46d8--2800a0--favorite",
  "vu": "x93eb46d8--2800a0--active",
  "id": "x93eb46d8--2800a0--discount",
};

module.exports = exports;
